import { each, filter, go, html, juxt, pluck } from 'fxjs/es';
import {
  $addClass,
  $closest,
  $data,
  $delegate,
  $el,
  $find,
  $findAll,
  $hide,
  $qs,
  $removeClass,
  $replaceWith,
  $setCss,
  $show,
} from 'fxdom/es';
import { NessLabsSettingF } from '../../Setting/F/Function/module/NessLabsSettingF.js';
import { NessLabsF } from './module/NessLabsF.js';
import { getCharacterSettingData } from './nesslabs.js';
import { NessLabsS } from '../../S/Function/module/NessLabsS.js';
import axios from 'axios';
import { makeApiUrl } from '../../../Util/S/Function/util.js';
import { NessLabsConstantS } from '../../S/Constant/module/NessLabsConstantS.js';
import { NessUtilF } from '../../../Ness/Util/F/Function/module/NessUtilF.js';
import { NessLabsTmplS } from '../../S/Tmpl/module/NessLabsTmplS.js';
import { CharacterValidatorS } from '../../S/Function/character.js';
import { MShopShareFramePopUpF } from '../../../MShop/ShareFrame/PopUp/F/Function/module/MShopShareFramePopUpF.js';
import { format } from 'date-fns';
import { NessLabsReloadDescriptionF } from '../../ReloadDescription/F/Function/module/NessLabsReloadDescriptionF.js';

export const CharacterValidator = {
  handleOldCharacterError: (character, hide_list = false) => {
    if (!CharacterValidatorS.isOldCharacter(character)) return false;

    if (hide_list) CharacterValidator.hideProductList();

    const { date_last_login } = character;
    MShopShareFramePopUpF.alert({
      title: ET('labs::can_not_load::title'),
      body: ET('labs::can_not_load::message'),
      optional: html` <div class="msg__item-list">
        <span class="msg__span">${ET('labs::can_not_load::last_date')}</span>
        <div class="msg__span-content">${format(new Date(date_last_login), 'yyyy.MM.dd')}</div>
      </div>`,
    });

    return true;
  },

  handleCollaboError: (character, hide_list = false) => {
    if (!CharacterValidatorS.isCollaboCharacter(character)) return false;

    if (hide_list) CharacterValidator.hideProductList();

    const { avatar_items, special_world_character_flag, gc_name } = character;
    if (special_world_character_flag) {
      MShopShareFramePopUpF.alert({
        title: ET('labs::error::special_world::title'),
        body: ET('labs::error::special_world::message'),
        optional: html` <div class="msg__item-list">
          <span class="msg__span">${ET('labs::error::special_world::name')}</span>
          <div class="msg__span-content">${gc_name}</div>
        </div>`,
      });
      return true;
    }

    const collabo_items = go(
      avatar_items,
      filter(({ collaboration_flag }) => collaboration_flag),
      pluck('item_name'),
    );
    MShopShareFramePopUpF.alert({
      title: ET('labs::error::title'),
      body: ET('labs::error::message'),
      optional: html` <div class="msg__item-list">
        <span class="msg__span"> ${ET('labs::error::item_name')}</span>
        <div class="msg__span-content">${collabo_items.join(', ')}</div>
      </div>`,
    });

    return true;
  },

  hideProductList: () => {
    go(
      $qs('.ness-plus-product-list[data-type="labs"]'),
      juxt($find('.change_motion'), $find('.labs__content-container'), $setCss({ 'min-height': 'unset' })),
      ([$motion_btn, $product_list, _]) => {
        $addClass('hidden', $motion_btn);
        $hide($product_list);
      },
    );
  },
};

const DOMHandler = {
  toggleList: (el) => {
    go(
      el,
      $closest('.character-swiper'),
      $findAll('.character-item'),
      each((item) => $removeClass('active', item)),
    );
    $addClass('active', el);
  },

  async updateCharacter(character) {
    const [img_container, info_container, not_login_container] = go(
      $qs('.labs__main-container'),
      juxt(
        $find('.labs__main-container__img-container'),
        $find('.info-container'),
        $find('.labs__main-container__content__not-login'),
      ),
    );

    const is_invaild = CharacterValidatorS.isInvalidCharacter(character);
    if (is_invaild) {
      $show(not_login_container);
      $hide(img_container);
    } else {
      $hide(not_login_container);
      const changed_img_container = $el(NessLabsTmplS.currentCharacterHtml(character));
      $replaceWith(changed_img_container, img_container);

      const canvas = $find('canvas', changed_img_container);
      await NessLabsS.initializeCanvases({
        canvas,
        size: NessLabsConstantS.CHARACTER_CANVAS_SIZE[NessUtilF.isMobile() ? 'MOBILE' : 'PC'].MAIN,
      });
    }

    $replaceWith($el(NessLabsTmplS.characterInfoHtml(character)), info_container);

    if (is_invaild) {
      CharacterValidator.hideProductList();
      return;
    }
    await NessLabsF.refreshProductList();
  },
};

const eventHandlers = {
  async handleCharacterSelect({ currentTarget }) {
    try {
      $.don_loader_start();
      const selected_character = $data(currentTarget);

      DOMHandler.toggleList(currentTarget);

      await DOMHandler.updateCharacter(selected_character);

      if (
        CharacterValidator.handleOldCharacterError(selected_character) ||
        CharacterValidator.handleCollaboError(selected_character)
      )
        return;

      await axios.post(makeApiUrl('/:lang/@api/ness/maple/labs/character/is_selected', { lang: T.lang }), {
        gcid: selected_character.gcid,
        world_id: selected_character.world_id,
      });
    } catch (e) {
      $.alert(e.response?.data?.message);
    } finally {
      $.don_loader_end();
    }
  },

  async handleMotionChange({ currentTarget }) {
    try {
      $.don_loader_start();
      const setting = getCharacterSettingData($closest('.labs__main-container__content', currentTarget));

      await NessLabsSettingF.openSetting(setting, async (data) => {
        const {
          gcid,
          world_id,
          selected_motions: { emotion, action, weapon },
        } = data;
        await DOMHandler.updateCharacter(data);
        const selected_character = $qs('.character-item.active');

        const character_item = $el(NessLabsTmplS.makeListItem({ character: data, is_active: true }));
        $replaceWith(character_item, selected_character);

        const canvas = $find('.character-thumbnail', character_item);

        const scaled = await NessLabsS.getScaleUpAndCenterCropCanvas(canvas.dataset.src, 300, 120, 120);
        canvas.width = scaled.width;
        canvas.height = scaled.height;
        canvas.getContext('2d').drawImage(scaled, 0, 0);

        await axios.post(makeApiUrl('/:lang/@api/ness/maple/labs/character/motion', { lang: T.lang }), {
          gcid,
          world_id,
          emotion,
          action,
          weapon,
        });
      });
    } catch (e) {
      $.alert(e.response?.data?.message);
    } finally {
      $.don_loader_end();
    }
  },

  async handleReloadCharacter() {
    $.don_loader_start();
    NessLabsF.resetProductList();
    box().stop_load = true;

    setTimeout(
      () => {
        if (NessUtilF.isMobile()) $.don_loader_end();
        window.location.reload();
      },
      NessUtilF.isMobile() ? 500 /* trick */ : 0,
    );
  },

  async openReloadDescription() {
    return NessLabsReloadDescriptionF.openReloaddescription();
  },
};

export const events = (el) =>
  go(
    el,
    $delegate('click', '.character-item', eventHandlers.handleCharacterSelect),
    $delegate('click', '.change_motion', eventHandlers.handleMotionChange),
    $delegate('click', '.reload_character, .reload-button', eventHandlers.handleReloadCharacter),
    $delegate('click', '.labs__main-container__reload-container__desc', eventHandlers.openReloadDescription),
  );
